import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import "rxjs/add/operator/map";
import "rxjs/Rx";

@Injectable()
export class AuthService {
  user: any;
  constructor(private http: Http) {}

  suscribeUser(user) {
    let headers = new Headers();

    headers.append("Content-Type", "application/json");
    return this.http
      .post("https://depistage-gilead.herokuapp.com/users/suscribe", user, {
        headers: headers,
      })
      .map((res) => res.json());
  }
  validateUser(token: String) {
    let headers = new Headers();

    headers.append("Content-Type", "application/json");
    return this.http
      .post("https://depistage-gilead.herokuapp.com/users/validateOpt", {token: token}, {
        headers: headers,
      })
      .map((res) => res.json());
  }
  //https://baxter-webinar-afbk.herokuapp.com/users/login
  authenticateUser(user) {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    return this.http
      .post("https://depistage-gilead.herokuapp.com/users/login", user, {
        headers: headers,
      })
      .map((res) => res.json());
  }

  /*getProfile(){

  let headers = new Headers();
  headers.append('Content-Type','application/json');
  return this.http.get('https://hidden-lake-30109.herokuapp.com/users/profile',{headers:headers})
  .map((res:Response)=> res.json);
  }*/

  loadUser() {
    const User = JSON.parse(localStorage.getItem("user"));

    this.user = User;
  }

  loggedin() {
    if (this.user != null) {
      return true;
    } else {
      return false;
    }
  }

  StoreUserData(user) {
    localStorage.setItem("user", JSON.stringify(user));
    this.user = user;
  }

  lougout() {
    this.user = null;
    localStorage.clear();
  }

  getAllUsers() {
    return this.http
      .get("https://depistage-gilead.herokuapp.com/users/admin")
      .map((res) => res.json());
  }

  ConvertToCSV(objArray) {
    var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    var str = "";
    var row = "";

    for (var index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ",";
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + "\r\n";

    for (var i = 0; i < array.length; i++) {
      var line = "";
      for (var index in array[i]) {
        if (line != "") line += ",";

        line += array[i][index];
      }
      str += line + "\r\n";
    }
    return str;
  }
  downloadFile(data) {
    var csvData = this.ConvertToCSV(data);
    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", "baxter.csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts